module.exports = __webpack_public_path__ + "img/invite_friends_bg.c580c89a.jpg";